import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';
import { initSentry } from './app/core/sentry';
import { installProductionScripts } from './app/core/analytics/bootstrap-scripts';

if (environment.production) {
  initSentry();
  installProductionScripts();
}

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
